export { default } from "./TableInfo";
